// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pjkzxpunlergxoqdokwv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBqa3p4cHVubGVyZ3hvcWRva3d2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk5MDM4MzUsImV4cCI6MjA1NTQ3OTgzNX0.wyIbNVTmRD0F6uluVbtP7_zEPFyoR2D2O1Y3gawD7kA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);